import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, LogIn } from "lucide-react";
import Logo from "../components/Logo";
import { api, setToken } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await api.post("/admin/login", form);
      setToken(r.data.token);
      navigate("/admin");
    } catch (e) {
      setErr("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#16244F] to-[#2b3f7a] px-5">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 md:p-10">
        <div className="flex justify-center mb-6">
          <Logo height={48} />
        </div>
        <h1 className="font-head text-2xl font-bold text-[#16244F] text-center">Admin Login</h1>
        <p className="text-center text-[#8a90a0] text-sm mt-1 mb-7">Manage appointments & blog posts</p>

        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <User size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a90a0]" />
            <input
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              placeholder="Username"
              required
              className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200 focus:border-[#2b8cf0] focus:ring-2 focus:ring-[#2b8cf0]/20 outline-none transition"
            />
          </div>
          <div className="relative">
            <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a90a0]" />
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Password"
              required
              className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200 focus:border-[#2b8cf0] focus:ring-2 focus:ring-[#2b8cf0]/20 outline-none transition"
            />
          </div>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold py-3.5 rounded-lg transition-colors disabled:opacity-70"
          >
            <LogIn size={18} /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
